import React, { useState } from 'react'
import { getProjectByName } from '../../../../utils/mergeData';
import { Box, Card, CardMedia, Container, Divider, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2'
import { getRiskValue, SolidGaugeChart } from './ClimateCharts';
import { Link } from 'react-router-dom';
import BiodiversityMap from '../../../../resources/images/biodevmap.png'
import areaCovered from '../../../../resources/images/site-area.png';
import scoreCovered from '../../../../resources/images/score.png';
import categoryCovered from '../../../../resources/images/category.png';
import Mapbox from '../ProjectMap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { ChartComponent } from '../../../common/chartComponent';
import ChartProjectionComponent from './climateProperty';
import ProjectOverview from '../../../../resources/images/Project_overview.png'
import EnvPara from '../../../../resources/images/envparameter.png'
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts'
import { text } from 'stream/consumers';
import DMapCA from '../DMap/DMapCA';
import { getIntactnessRangeCategory } from '../../../../constants/index';
import { convertToNumber } from '../../../../constants/index';
import DMapDashBoard from '../DMap/DMapDashboard';

const EnvDashboard = () => {
  const [projectSite, setProjectList] = useState([]);
  const [defaultProjectSite, setDefaultProjectList] = useState([]);
  const selectedProjectStr = localStorage.getItem('selectedProject');
  const selectedProject = selectedProjectStr ? JSON.parse(selectedProjectStr) : null;

  const currentProject = getProjectByName(selectedProject?.project_name);

  const filterClimateProjecion = currentProject?.Climate_Projections;

  const filterOptimisticDayNearTerm = filterClimateProjecion?.[0]?.Optimistic_Scenario?.Near_Term;
  const filterOptimisticDayMidTerm = filterClimateProjecion?.[0]?.Optimistic_Scenario?.Mid_Term;
  const filterOptimisticDayLongTerm = filterClimateProjecion?.[0]?.Optimistic_Scenario?.Long_Term;

  const filterIntermidiateNearTerm = filterClimateProjecion?.[0]?.Intermediate_Scenario?.Near_Term;
  const filterIntermidiateMidTerm = filterClimateProjecion?.[0]?.Intermediate_Scenario?.Mid_Term;
  const filterIntermidiateLongTerm = filterClimateProjecion?.[0]?.Intermediate_Scenario?.Long_Term;

  const filterExtremeNearTerm = filterClimateProjecion?.[0]?.Extreme_Scenario?.Near_Term;
  const filterExtremeMidTerm = filterClimateProjecion?.[0]?.Extreme_Scenario?.Mid_Term;
  const filterExtremeLongTerm = filterClimateProjecion?.[0]?.Extreme_Scenario?.Long_Term;

  const filterOptimisticCycloneNearTerm = filterClimateProjecion?.[0]?.Optimistic_Scenario?.Near_Term;
  const filterOptimisticCycloneMidTerm = filterClimateProjecion?.[0]?.Optimistic_Scenario?.Mid_Term;
  const filterOptimisticCycloneLongTerm = filterClimateProjecion?.[0]?.Optimistic_Scenario?.Long_Term;

  const filterIntermidiateCycloneNearTerm = filterClimateProjecion?.[0]?.Intermediate_Scenario?.Near_Term;
  const filterIntermidiateCycloneMidTerm = filterClimateProjecion?.[0]?.Intermediate_Scenario?.Mid_Term;
  const filterIntermidiateCycloneLongTerm = filterClimateProjecion?.[0]?.Intermediate_Scenario?.Long_Term;

  const filterExtremeCycloneNearTerm = filterClimateProjecion?.[0]?.Extreme_Scenario?.Near_Term;
  const filterExtremeCycloneMidTerm = filterClimateProjecion?.[0]?.Extreme_Scenario?.Mid_Term;
  const filterExtremeCycloneLongTerm = filterClimateProjecion?.[0]?.Extreme_Scenario?.Long_Term;


  const chartData1 = {
    optimisticNearTerm: parseFloat(filterOptimisticDayNearTerm?.Consecutive_Dry_Days?.change || '0'),
    optimisticMidTerm: parseFloat(filterOptimisticDayMidTerm?.Consecutive_Dry_Days?.change || '0'),
    optimisticLongTerm: parseFloat(filterOptimisticDayLongTerm?.Consecutive_Dry_Days?.change || '0'),

    intermediaryNearTerm: parseFloat(filterIntermidiateNearTerm?.Consecutive_Dry_Days?.change || '0'),
    intermediaryMidTerm: parseFloat(filterIntermidiateMidTerm?.Consecutive_Dry_Days?.change || '0'),
    intermediaryLongTerm: parseFloat(filterIntermidiateLongTerm?.Consecutive_Dry_Days?.change || '0'),

    extremeNearTerm: parseFloat(filterExtremeNearTerm?.Consecutive_Dry_Days?.change || '0'),
    extremeMidTerm: parseFloat(filterExtremeMidTerm?.Consecutive_Dry_Days?.change || '0'),
    extremeLongTerm: parseFloat(filterExtremeLongTerm?.Consecutive_Dry_Days?.change || '0'),
  };

  const chartOptions1 = {
    chart: {
      type: 'column',  // Set chart type to bar
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: ['Near Term', 'Mid Term', 'Long Term'], // Categories for x-axis
    },
    yAxis: {
      title: {
        text: 'Consecutive Dry Days',
      },
      stackLabels: {
        enabled: true,  // Show stack labels
        style: {
          fontWeight: 'bold',
          color: 'gray',
        },
      },
    },
    tooltip: {
      shared: true,
      valueSuffix: 'days',
    },
    series: [
      {
        name: 'Optimistic',
        data: [
          chartData1.optimisticNearTerm,
          chartData1.optimisticMidTerm,
          chartData1.optimisticLongTerm,
        ],
        color: '#8884d8',
      },
      {
        name: 'Intermediary',
        data: [
          chartData1.intermediaryNearTerm,
          chartData1.intermediaryMidTerm,
          chartData1.intermediaryLongTerm,
        ],
        color: '#ff6347', // Red
      },
      {
        name: 'Extreme',
        data: [
          chartData1.extremeNearTerm,
          chartData1.extremeMidTerm,
          chartData1.extremeLongTerm,
        ],
        color: '#ff0000', // Dark Red
      },
    ],
  };

  const chartData2 = {
    optimisticNearTerm: parseFloat(filterOptimisticCycloneNearTerm?.Cyclone_Frequency?.change || '0'),
    optimisticMidTerm: parseFloat(filterOptimisticCycloneMidTerm?.Cyclone_Frequency?.change || '0'),
    optimisticLongTerm: parseFloat(filterOptimisticCycloneLongTerm?.Cyclone_Frequency?.change || '0'),

    intermediaryNearTerm: parseFloat(filterIntermidiateCycloneNearTerm?.Cyclone_Frequency?.change || '0'),
    intermediaryMidTerm: parseFloat(filterIntermidiateCycloneMidTerm?.Cyclone_Frequency?.change || '0'),
    intermediaryLongTerm: parseFloat(filterIntermidiateCycloneLongTerm?.Cyclone_Frequency?.change || '0'),

    extremeNearTerm: parseFloat(filterExtremeCycloneNearTerm?.Cyclone_Frequency?.change || '0'),
    extremeMidTerm: parseFloat(filterExtremeMidTerm?.Cyclone_Frequency?.change || '0'),
    extremeLongTerm: parseFloat(filterExtremeCycloneLongTerm?.Cyclone_Frequency?.change || '0'),
  };

  const chartOptions2 = {
    chart: {
      type: 'column',  // Set chart type to bar
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: ['Near Term', 'Mid Term', 'Long Term'], // Categories for x-axis
    },
    yAxis: {
      title: {
        text: 'Cyclone Frequency',
      },
      stackLabels: {
        enabled: true,  // Show stack labels
        style: {
          fontWeight: 'bold',
          color: 'gray',
        },
      },
    },
    tooltip: {
      shared: true,
      valueSuffix: 'cyclone',
    },
    series: [
      {
        name: 'Optimistic',
        data: [
          chartData2.optimisticNearTerm,
          chartData2.optimisticMidTerm,
          chartData2.optimisticLongTerm,
        ],
        color: '#00aaff',
      },
      {
        name: 'Intermediary',
        data: [
          chartData2.intermediaryNearTerm,
          chartData2.intermediaryMidTerm,
          chartData2.intermediaryLongTerm,
        ],
        color: '#ff6347', // Red
      },
      {
        name: 'Extreme',
        data: [
          chartData2.extremeNearTerm,
          chartData2.extremeMidTerm,
          chartData2.extremeLongTerm,
        ],
        color: '#ff0000', // Dark Red
      },
    ],
  };
  const acuteRisksCategory = [
    { name: "Cold Stress", riskLevel: currentProject?.Acute_risks?.[0]?.Extreme_cold_risk || '', value: getRiskValue(currentProject?.Acute_risks?.[0]?.Extreme_cold_risk || '') },
    { name: "Precipitation", riskLevel: currentProject?.Acute_risks?.[0]?.Extreme_precipitation_risk || '', value: getRiskValue(currentProject?.Acute_risks?.[0]?.Extreme_precipitation_risk || '') },
    { name: "Landslide", riskLevel: currentProject?.Acute_risks?.[0]?.Landslide_risk || '', value: getRiskValue(currentProject?.Acute_risks?.[0]?.Landslide_risk || '') },
    { name: "Cyclone", riskLevel: currentProject?.Acute_risks?.[0]?.Tropical_cyclone_risk || '', value: getRiskValue(currentProject?.Acute_risks?.[0]?.Tropical_cyclone_risk || '') },
    { name: "Wildfire", riskLevel: currentProject?.Acute_risks?.[0]?.Wildfire_risk || '', value: getRiskValue(currentProject?.Acute_risks?.[0]?.Wildfire_risk || '') },
  ];
  const ChronicRisksCategory = [
    { name: "Flood", riskLevel: currentProject?.Chronic_risks?.[0]?.Flood_risk || '', value: getRiskValue(currentProject?.Chronic_risks?.[0]?.Flood_risk || '') },
    { name: "Drought", riskLevel: currentProject?.Chronic_risks?.[0]?.Drought_risk || '', value: getRiskValue(currentProject?.Chronic_risks?.[0]?.Drought_risk || '') },
    { name: "Heat Wave", riskLevel: currentProject?.Chronic_risks?.[0]?.Extreme_heat_risk || '', value: getRiskValue(currentProject?.Chronic_risks?.[0]?.Extreme_heat_risk || '') },
    { name: "Sea Level Rise", riskLevel: currentProject?.Chronic_risks?.[0]?.["Sea Sea_level_rise_risk"] || '', value: getRiskValue(currentProject?.Chronic_risks?.[0]?.["Sea Sea_level_rise_risk"] || '') },
  ]
  const handleSelectEnvSite = (site: any) => {
    localStorage.setItem('SelectedDropDownEnvSite', JSON.stringify(site))
  }

  const handleChartClick = () => {
    console.log("Solid Gauge chart clicked!");
  };
  return (
    <Box sx={{ mt: 5 }}>
      <Box className='bio-map' sx={{ mb: 3 }}>
        {/* <DMapCA /> */}
        <DMapDashBoard />
      </Box>

      <Box sx={{
        flex: 1,
        overflowY: 'auto',
        border: '1px solid #ccc',
        backgroundColor: "#fff",
        margin: "10px 1px",
        borderRadius: "8px",
        padding: 2, // Added padding for content spacing
        maxHeight: "550px"
      }}>
        <Typography sx={{ fontWeight: 600, fontSize: "22px", color: "#151E15", marginBottom: 2 }}>
          {currentProject?.project_name}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #D9D9D9' }} gap={2} />

        <Grid container spacing={4}>
          <Grid size={{ xs: 6 }} >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box
                component="img"
                src={ProjectOverview}
                alt="Project Overview"
                sx={{
                  width: "45px",
                  height: "35px",
                  objectFit: "contain", // Ensures the image fits within its dimensions
                }}
              />
              <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#151E15", padding: "16px" }}>
                {'Project Details'}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #D9D9D9' }} gap={2} />
            <Box sx={{ display: 'flex', flexDirection: 'column', padding: "16px", marginLeft: '40px' }} gap={2}>
              <Box>
                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                  {'Project Id'}
                </Typography>
                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                  {currentProject?.project_id}
                </Typography>
              </Box>
              <Box>
                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                  {'Total Area'}
                </Typography>
                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                  {currentProject?.total_area}
                </Typography>
              </Box>
              <Box>
                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                  {'Total Sites'}
                </Typography>
                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                  {currentProject?.number_of_sites}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid size={{ xs: 6 }} >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box
                component="img"
                src={EnvPara}
                alt="Project Overview"
                sx={{
                  width: "45px",
                  height: "35px",
                  objectFit: "contain", // Ensures the image fits within its dimensions
                }}
              />
              <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#151E15", padding: "16px" }}>
                {'Environmental Parameters'}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #D9D9D9' }} gap={2} />
            <Box sx={{ display: 'flex' }}>

              <Box sx={{ display: 'flex', flexDirection: 'column', padding: "16px", marginLeft: "40px" }} gap={2}>
                <Box>
                  <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                    {'Overall Risk Score'}
                  </Typography>
                  <Typography sx={{ color: getIntactnessRangeCategory(convertToNumber(currentProject?.Overall_risk_score ?? 0)).color, fontWeight: 500, fontSize: '20px' }}>
                    {currentProject?.Overall_risk_score}
                  </Typography>
                </Box>
                <Box>
                  <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                    {'Value Risk'}
                  </Typography>
                  <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                    {currentProject?.Value_at_risk}
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ display: 'flex', flexDirection: 'column', padding: "16px" }} gap={2}>
                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                  {'Overall Risk Category'}
                </Typography>
                <SolidGaugeChart
                  title={''}
                  value={getRiskValue(currentProject?.Overall_risk_category || '')}
                  riskLevel={currentProject?.Overall_risk_category as "High" | "Moderate" | "Low"}
                  riskLevelTitle={currentProject?.Overall_risk_category || ''}
                  isClickable={false}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>

      </Box>

      <Box sx={{ mb: 2 }}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 6 }} className='project-box'>

            <Typography sx={{ fontWeight: 600, fontSize: "22px", color: "#151E15", m: 2 }}>
              {'Acute Risk'}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #D9D9D9' }} gap={2} />
            <Box style={{ display: "flex", flexWrap: "wrap", gap: "16px", borderRadius: "10px" }}>
              {acuteRisksCategory.map((category, index) => (
                <Box key={index}
                  style={{ width: "200px" }}>
                  <SolidGaugeChart
                    title={category.name}
                    value={category.value}
                    riskLevel={category.riskLevel as "High" | "Moderate" | "Low" | "ModerateHigh" | "ModerateLow"}
                    riskLevelTitle={category.riskLevel}
                    onClick={handleChartClick}
                    isClickable={true}
                  />
                </Box>
              ))}
            </Box>
          </Grid>

          <Grid size={{ xs: 6 }} className="project-box">
            <Typography sx={{ fontWeight: 600, fontSize: "22px", color: "#151E15", m: 2 }}>
              {'Chronic Risk'}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #D9D9D9' }} gap={2} />
            <Box style={{ display: "flex", flexWrap: "wrap", gap: "16px", borderRadius: "10px" }}>
              {ChronicRisksCategory.map((category, index) => (
                <Box key={index}
                  style={{ width: "200px" }}>
                  <SolidGaugeChart
                    title={category.name}
                    value={category.value}
                    riskLevel={category.riskLevel as "High" | "Moderate" | "Low" | "ModerateHigh" | "ModerateLow"}
                    riskLevelTitle={category.riskLevel}
                    onClick={handleChartClick}
                    isClickable={true}
                  />
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Card sx={{
        boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.1019607843) !important",
        borderRadius: '8px',
        backgroundColor: '#fff',
      }}>
        <ChartProjectionComponent />
        <Box className='divider' sx={{ m: 1 }} />
        <Grid container spacing={3}>
          <Grid size={{ xs: 6 }} sx={{ ml: 3 }}>
            <Typography
              component="div"
              sx={{ textAlign: "left", fontSize: "16px", fontWeight: 600, color: '#151E15', p: "16px" }}
            >
              {'Consecutive Days'}
            </Typography>
            <Box className='divider' sx={{ m: 2 }} />
            <HighchartsReact highcharts={Highcharts} options={chartOptions1} />
          </Grid>
          <Box sx={{ borderLeft: '1px solid #c4c4c4' }} />
          <Grid size={{ xs: 5 }}>
            <Typography
              component="div"
              sx={{ textAlign: "left", fontSize: "16px", fontWeight: 600, color: '#151E15', p: "16px" }}
            >
              {'Cyclone Frequency'}
            </Typography>
            <Box className='divider' sx={{ m: 2 }} />
            <HighchartsReact highcharts={Highcharts} options={chartOptions2} />
          </Grid>
        </Grid>
      </Card>

      <Typography sx={{ fontSize: "24px", fontWeight: 600, color: "#151E15", margin: "5px" }}>{'Project Sites'}</Typography>
      <Box sx={{
        display: 'flex',
        gap: 2,
        p: 1,
      }}>
        <Swiper navigation={true} modules={[Navigation]} slidesPerView={3}
          spaceBetween={30}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}>
          {currentProject && (currentProject as any)?.sites?.map((site: any, index: any) => {
            return (
              <SwiperSlide>
                <Link to={`/environmentalreport-analysis-detail`} style={{ textDecoration: 'none' }} key={index} onClick={() => handleSelectEnvSite(site)}>
                  <Card sx={{ display: 'flex', backgroundColor: "#151E15", borderRadius: 2, overflow: 'hidden' }}>
                    <Box sx={{ flex: 1 }}>
                      <CardMedia
                        component="img"
                        sx={{ height: '100%', objectFit: 'cover' }}
                        image={BiodiversityMap}
                        alt="Site image"
                      />
                    </Box>

                    <Box sx={{
                      display: 'flex', flexDirection: 'column', padding: 2, gap: 1.5,
                      flex: 1
                    }}>
                      <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#fff" }}>
                        {site.site_name}
                      </Typography>
                      <Typography sx={{ fontWeight: 600, fontSize: "15px", color: "#fff" }}>
                        {site.type}
                      </Typography>

                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, color: '#fff' }}>
                          <img src={areaCovered} alt="area covered" style={{ width: 20, height: 20 }} />
                          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography component="div" sx={{ fontSize: "12px", fontWeight: 500 }}>
                              {'Area Covered'}
                            </Typography>
                            <Typography component="div" sx={{ fontSize: "18px", fontWeight: 600 }}>
                              {site?.area}
                            </Typography>
                          </Box>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, color: '#fff' }}>
                          <img src={scoreCovered} alt="camera installed" style={{ width: 20, height: 20 }} />
                          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography component="div" sx={{ fontSize: "12px", fontWeight: 500 }}>
                              {'Site Risk Score'}
                            </Typography>
                            <Typography component="div" sx={{ fontSize: "18px", fontWeight: 600 }}>
                              {site?.site_risk_score}
                            </Typography>
                          </Box>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, color: '#fff' }}>
                          <img src={categoryCovered} alt="audio devices" style={{ width: 20, height: 20 }} />
                          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography component="div" sx={{ fontSize: "12px", fontWeight: 500 }}>
                              {'Site Risk Category'}
                            </Typography>
                            <Typography component="div" sx={{ fontSize: "18px", fontWeight: 600 }}>
                              {site?.site_risk_category}
                            </Typography>
                          </Box>
                        </Box>

                      </Box>
                    </Box>
                  </Card>
                </Link>
              </SwiperSlide>
            )
          })}
        </Swiper>
      </Box>


    </Box>

  )
}

export default EnvDashboard